(() => {
  'use strict';

  const selector = '[data-faj-technical-services]';

  function reveal(section) {
    if (!section || section.dataset.ftsInitialized === 'true') return;
    section.dataset.ftsInitialized = 'true';

    if (!section.classList.contains('fts-section--animate')) {
      section.classList.add('is-visible');
      return;
    }

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.12
      }
    );

    observer.observe(section);
    section.ftsObserver = observer;
  }

  function initAll(scope = document) {
    if (scope.matches?.(selector)) reveal(scope);
    scope.querySelectorAll?.(selector).forEach(reveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(selector)
      ? event.target
      : event.target.querySelector?.(selector);

    section?.ftsObserver?.disconnect?.();
  });
})();
